import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onCreateKvkk,
  onGetKvkk,
  onUpdateKvkk,
} from '../../../app/modules/areas/admin/Kvkk/core/_requests'

interface KvkkState {
  kvkk: any
}

const initialState = {
  kvkk: null,
} as KvkkState

export const fetchKvkk = createAsyncThunk('kvkk/fetchKvkk', async (param : any) => {
  const data: any = await onGetKvkk(param)
  return data.data.result
})

export const updateKvkk = createAsyncThunk('kvkk/updateKvkk', async (param: any) => {
  const data: any = await onUpdateKvkk(param)
  return data.data
})

export const createKvkk = createAsyncThunk('kvkk/createKvkk', async (param: any) => {
  const data: any = await onCreateKvkk(param)
  return data.data
})

const kvkkSlice = createSlice({
  name: 'kvkk',
  initialState,
  reducers: {
    clearKvkk: (state) => {
      state.kvkk = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchKvkk.fulfilled, (state: any, action) => {
      state.kvkk = action.payload
    })
  },
})

export const {clearKvkk} = kvkkSlice.actions

export default kvkkSlice.reducer
